import { useState, useEffect } from "react";
import { Card, CardActions, CardContent, CardHeader, Divider, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LoadingButton } from "@mui/lab";

export default function FirstMileSMS({
    message,
    updateSMSMessage,
    error,
    isSuccess,
    loading
}) {
    const { t } = useTranslation()
    const [value, setValue] = useState('');

    const handleChange = (event) => {
        setValue(event.target.value);
    };

    useEffect(() => {
        if (!!message) setValue(message)
    }, [message])

    return (
        <Card>
            <CardHeader title={t("SMS")} />
            <Divider />
            <CardContent>
                <TextField
                    label={t("Enter your SMS")}
                    fullWidth
                    size="small"
                    variant="outlined"
                    multiline
                    value={value}
                    onChange={handleChange}
                />
            </CardContent>
            <Divider />
            <CardActions sx={{ display: "flex", justifyContent: "space-between" }}>
                {!!error && <Typography color="error">{t(error)}</Typography>}
                {!!isSuccess && <Typography color="green.main">{t("Done successfully")}</Typography>}
                <LoadingButton
                    color="main"
                    variant="contained"
                    disableElevation
                    onClick={() => updateSMSMessage({ message: value })}
                    loading={loading}
                    disabled={!Boolean(value)}
                    sx={{ mt: 1, textTransform: "none", fontWeight: "bold" }}
                >
                    {t("Confirm")}
                </LoadingButton>
            </CardActions>
        </Card>
    )
}